import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getInactiveReport = async ({
    view,
    inactivityPeriod,
    teamLeaderId = null,
    includeInactiveClients = false,
}) => {
    try {
        const token = Cookies.get("Bearer");
        const params = { view, inactivityPeriod };

        if (teamLeaderId) {
            params.teamLeaderId = teamLeaderId;
        }

        if (view === "Clients") {
            params.includeInactiveClients = Boolean(includeInactiveClients);
        }

        const response = await axios.get(
            `${FIRMFLOWURL}api/Analytics/inactiveReport`,
            {
                headers: { Authorization: token },
                params,
            },
        );

        const success = response?.data?.success !== false;

        return {
            ...response,
            success,
            message: success
                ? undefined
                : response?.data?.message ??
                  response?.data?.Message ??
                  "Error loading Inactive Report.",
        };
    } catch (err) {
        console.log(err);
        const status = err.response?.status;

        if (status === 401 || err.message.includes("401")) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return;
        }

        return {
            success: false,
            status,
            data: err.response?.data,
            message:
                err.response?.data?.message ??
                err.response?.data?.Message ??
                err.message,
        };
    }
};
